module.exports = __webpack_public_path__ + "static/media/PDF.6065a48f.png";